import { EItemId } from '../enums';

import { ItemTypeEnum } from './item-type.constant';
import { MarketCategory } from './market-category.constant';

export interface IItemDto {
  code: string;
  name: string;
  rarity: string;
  type: ItemTypeEnum;
  marketTags: MarketCategory[];
  description: string;
  iconUrl: string;
  levelRequirement: number;
  unavailable?: boolean | undefined;
}
export interface IRewardItem {
  rewardItem: IItem;
  count: number;
}

export interface IReward {
  itemId: EItemId;
  count: number;
}

export interface IItem {
  code: EItemId;
  name: string;
  type: ItemTypeEnum;
  marketTags: MarketCategory[];
  levelRequirement: number;
  dischantItemCode: string | null;
  dischantItemCount: number | null;
  rarity: ItemRarityEnum;
  description: string;
  iconUrl: string;
  unavailable?: boolean | undefined;
  allowedCountryCodes?: string[]; // If present and non-empty, the student's country must be in the set to acquire/view the item
  blockedCountryCodes?: string[]; // If present and non-empty, the student's country must NOT be in the set to acquire/view the item
}

export enum ItemRarityEnum {
  COMMON = 'common',
  UNCOMMON = 'uncommon',
  RARE = 'rare',
  LEGENDARY = 'legendary',
  EPIC = 'epic'
}
